import '@cian/base-css/base.css';
import '@cian/components/lib/index.css';

import '@cian/base-css/lato.css';

import './bundles/common/legacy/components/index.css';
import './bundles/elements/legacy/components/index.css';

import './bundles/app_banner/index';

import initBusinessShoppingCenterDetail from './bundles/business_shopping_center_detail/index';
import initMainPage from './bundles/mainpage/index';
import initSentry from './bundles/sentry/index';

import initPopup from './bundles/popup/index';
import store from './di/store-bsc-detail';

import throttle = require('lodash/throttle');

initSentry();
initMainPage();
initBusinessShoppingCenterDetail(store);
initPopup(store);

// tslint:disable-next-line:no-any
(window as any).lodashThrottle = throttle;



// WEBPACK FOOTER //
// ./src/entry-bsc-card-ts.ts